var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VCard',{staticClass:"pa-0 pa-md-4 px-md-12 mb-5 grey--text text--darken-4",attrs:{"elevation":"1"}},[_c('div',[_vm._v(_vm._s(_vm.$t('title')))])])}
var staticRenderFns = []

export { render, staticRenderFns }